import {
  SET_CAMERA_OPEN,
  SET_CAMERA_CLOSED,
  SET_PREFERRED_CAMERA,
  RESTORE_CAMERA_STATE
} from '../constants';

const initialState = {
  isOpen: false,
  location: null,
  preferredCameraId: null
};

const cameraScannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMERA_OPEN:
      return {
        ...state,
        isOpen: true,
        location: action.payload.location
      };
    
    case SET_CAMERA_CLOSED:
      return {
        ...state,
        isOpen: false,
        location: null
      };
    
    case SET_PREFERRED_CAMERA:
      return {
        ...state,
        preferredCameraId: action.payload
      };
    
    case RESTORE_CAMERA_STATE:
      return {
        ...state,
        isOpen: action.payload.isOpen,
        location: action.payload.location,
        preferredCameraId: action.payload.preferredCameraId
      };
    
    default:
      return state;
  }
};

export default cameraScannerReducer;

